(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tp-footer-links"] && !Shopify.designMode) return;
  try {
    /* Cookie-Einstellungen: oeffnet den Einstellungsdialog des Shopify-Banners.
     Greift fuer jeden Link auf #cookie-einstellungen, also auch fuer Links im
     Text der Datenschutzerklaerung (/policies/* rendert im Theme-Layout), und
     beim Aufruf einer Seite mit diesem Anker. Das Banner-Skript kann spaeter
     laden als dieser Code, deshalb mehrere Versuche. */
  (function () {
    var ANKER = '#cookie-einstellungen';
    function oeffnen(versuche) {
      var banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        banner.showPreferences();
        return;
      }
      if (versuche > 0) setTimeout(function () { oeffnen(versuche - 1); }, 250);
    }
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href$="' + ANKER + '"]');
      if (!link) return;
      event.preventDefault();
      oeffnen(20);
    });
    if (window.location.hash === ANKER) oeffnen(20);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tp-groessen-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tp-groessen-form')) {
    class TpGroessenForm extends HTMLElement {
      connectedCallback() {
        this.tpAbbruch = new AbortController();
        const { signal } = this.tpAbbruch;
        this.addEventListener(
          'change',
          (event) => {
            const feld = event.target;
            if (!(feld instanceof HTMLInputElement) || !feld.hasAttribute('data-tp-gf-wert')) return;
            this.waehle(feld.value);
          },
          { signal }
        );

        // Horizon rendert bei einem Variantenwechsel nicht den ganzen Block
        // neu, sondern schickt das frische Section-HTML per variant:update.
        // Daraus wird der Inhalt uebernommen - Farbe der Bilder, Preise und
        // Auswahl kommen so weiter vom Server, nicht aus diesem Skript.
        const bereich = this.closest('.shopify-section, dialog');
        bereich?.addEventListener(
          'variant:update',
          (event) => {
            const html = event.detail?.data?.html;
            const neu = html?.querySelector('tp-groessen-form');
            if (neu) this.innerHTML = neu.innerHTML;
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.tpAbbruch?.abort();
      }

      waehle(wert) {
        const aktuell = this.querySelector('[data-tp-gf-aktuell]');
        if (aktuell) aktuell.textContent = wert;

        const name = this.dataset.optionName || '';
        const bereich = this.closest('.shopify-section') || document;
        const radios = Array.from(bereich.querySelectorAll('variant-picker input[type="radio"]')).filter(
          (feld) => feld.name.indexOf(name + '-') === 0
        );
        const ziel = radios.find((feld) => feld.value === wert);
        if (ziel) {
          if (ziel.checked) return;
          radios.forEach((feld) => {
            feld.checked = feld === ziel;
          });
          ziel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const auswahl = Array.from(bereich.querySelectorAll('variant-picker select')).find(
          (feld) => feld.name === 'options[' + name + ']'
        );
        if (auswahl && auswahl.value !== wert) {
          auswahl.value = wert;
          auswahl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('tp-groessen-form', TpGroessenForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tp-teppich-struktur"] && !Shopify.designMode) return;
  try {
    (function () {
    function variante() {
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      return m ? m[1] : null;
    }
    document.querySelectorAll('[data-tp-tts]').forEach(function (root) {
      var daten;
      try { daten = JSON.parse(root.querySelector('[data-tp-tts-daten]').textContent); } catch (e) { return; }
      var bild = root.querySelector('[data-tp-tts-bild]');
      var farbe = root.querySelector('[data-tp-tts-farbe]');
      var gross = root.querySelector('[data-tp-tts-gross]');
      var titel = bild.alt.split(',').slice(0, -1).join(',');
      function zeigen(id) {
        var d = id && daten[String(id)];
        if (!d || bild.getAttribute('src') === d.src) return;
        bild.src = d.src;
        bild.alt = titel + ', ' + d.farbe;
        if (gross && d.gross) { gross.src = d.gross; gross.alt = gross.alt.split(',').slice(0, -1).join(',') + ', ' + d.farbe; }
        if (farbe) farbe.textContent = d.farbe;
      }
      document.addEventListener('tp:farbe-wechsel', function (e) { zeigen(e.detail && e.detail.variantId); });
      document.addEventListener('variant:update', function () { setTimeout(function () { zeigen(variante()); }, 80); });
      document.addEventListener('change', function () { setTimeout(function () { zeigen(variante()); }, 150); });
      window.addEventListener('popstate', function () { zeigen(variante()); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
